var defaultStyles = {
  "group_wrapper": "Base-InputSearch--GroupWrapper",
  "input_search": "Base-InputSearch--InputSearch",
  "button": "Base-InputSearch--Button"
};

export { defaultStyles as default };
